export enum CarBrand {
  Lamborgini = "Lamborgini",
  Lada = "Lada",
}
